var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { isClassicWorkspaceById } from "@ane/exp-data/lib/utils/ManagementGroup";
import { jsxs, jsx } from "react/jsx-runtime";
import * as React from "react";
import { connect } from "react-redux";
import { TextField } from "@ane/ui-components/lib/components/TextField";
import { Selection, SelectionMode } from "@ane/ui-components/lib/Utilities";
import { AriaLabel, PlaceHolder, ComputeType } from "./models/ComputeAbstract.js";
import { AuthenticationType } from "./module/constants/ComputeResource.constants.js";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import { StepContainer } from "@ane/ui-components/lib/components/StepContainer";
import { FormHeading } from "@ane/ui-components/lib/components/FormHeading";
import { FormSection } from "@ane/ui-components/lib/components/FormSection";
import { DropdownField } from "@ane/ui-components/lib/components/FormikFormFields/DropdownField";
import { ChoiceGroupField } from "@ane/ui-components/lib/components/FormikFormFields/ChoiceGroupField";
import { SubClusterList, GetSubClisterListWhenAddChild } from "./module/views/ComputeCreate/components/SubClusterList/SubClusterList.js";
import { SubClusterListV2 } from "./module/views/ComputeCreate/components/SubClusterList/SubClusterListV2.js";
const getSynapseValidateMessage = (name, value) => {
  if (!value || "" === value.toString().trim()) {
    return "Required";
  }
  switch (name.toLowerCase()) {
    case "fixedworkers":
    case "minworkers":
    case "maxworkers":
    case "maxconcurrency":
      if (!/^[0-9]*[1-9][0-9]*$/.test(value)) {
        return "Please enter an integer greater than 0";
      } else {
        return "";
      }
    case "cluster":
      if (!/^cosmos[0-9]{2}$/.test(value)) {
        return "The field cluster must match the placeholder expression. e.g. cosmos09";
      } else {
        return "";
      }
    case "name":
      if (!/^[a-zA-Z0-9-_]{1,128}$/.test(value)) {
        return "Name is invalid. Only alphanumeric characters, hyphens, and underscores are allowed.";
      } else {
        return "";
      }
    case "developmenturl":
      try {
        new URL(value);
      } catch (_) {
        return "Require url";
      }
      return "";
    default:
      return "";
  }
};
const mapStateToProps = (state, props) => {
  return {
    //workspaceId: state.currentUserDetails.userAffinity?.data?.workspaceId || ''
  };
};
var ClusterScale = /* @__PURE__ */ ((ClusterScale2) => {
  ClusterScale2["Fixed"] = "Fixed";
  ClusterScale2["AutoScaling"] = "AutoScaling";
  return ClusterScale2;
})(ClusterScale || {});
const DefaultNodeSize = "Default";
class SynapseSubClusterComponent extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "_selection");
    __publicField(this, "onAddChild", () => {
      let defaultChild = {
        Name: "",
        DevelopmentUrl: "",
        StorageAccount: "",
        StorageContainer: "",
        PoolName: "",
        MaxConcurrency: "",
        NodeSize: "Small",
        ScaleType: "Fixed",
        FixedWorkers: "",
        MinWorkers: "",
        MaxWorkers: "",
        SparkVersion: "Spark 2.4",
        required: {
          Name: "",
          DevelopmentUrl: "",
          StorageAccount: "",
          StorageContainer: "",
          PoolName: "",
          MaxConcurrency: "",
          ScaleType: "",
          FixedWorkers: "",
          MinWorkers: "",
          MaxWorkers: "",
          SparkVersion: ""
        }
      };
      let subClusterList = GetSubClisterListWhenAddChild(this.props.subClusterList, defaultChild);
      this.props.setFieldValue && this.props.setFieldValue("synapseSubClusterList", subClusterList, true);
    });
    __publicField(this, "_onRenderRow", (props) => {
      if (!props) {
        return null;
      }
      const listIndex = props.itemIndex;
      return /* @__PURE__ */ jsxs(
        "div",
        {
          style: { paddingLeft: !EnvironmentService.enableSubClusterA11yUpdate() ? "85px" : void 0 },
          role: !EnvironmentService.enableSubClusterA11yUpdate() ? "row" : void 0,
          children: [
            /* @__PURE__ */ jsx("div", { role: !EnvironmentService.enableSubClusterA11yUpdate() ? "cell" : void 0, children: /* @__PURE__ */ jsx(
              TextField,
              {
                label: AriaLabel.SubClusterName,
                required: true,
                ariaLabel: AriaLabel.SubClusterName,
                isReadOnly: !!this.props.isReadOnly,
                description: PlaceHolder.SubClusterName,
                value: `${this.props.subClusterList && this.props.subClusterList[listIndex].Name}`,
                errorMessage: `${this.props.subClusterList && (this.props.subClusterList.length > 0 ? this.props.subClusterList[listIndex]["required"].Name : "")}`,
                onChange: (index, newValue) => {
                  this._handleChange(listIndex, newValue, "Name");
                }
              }
            ) }),
            /* @__PURE__ */ jsx("div", { role: !EnvironmentService.enableSubClusterA11yUpdate() ? "cell" : void 0, children: /* @__PURE__ */ jsx(
              TextField,
              {
                label: AriaLabel.DevelopmentUrl,
                required: true,
                ariaLabel: AriaLabel.DevelopmentUrl,
                isReadOnly: !!this.props.isReadOnly,
                description: PlaceHolder.DevelopmentUrl,
                value: `${this.props.subClusterList && this.props.subClusterList[listIndex]["DevelopmentUrl"]}`,
                onChange: (index, newValue) => {
                  this._handleChange(listIndex, newValue, "DevelopmentUrl");
                },
                errorMessage: `${this.props.subClusterList && (this.props.subClusterList.length > 0 ? this.props.subClusterList[listIndex]["required"].DevelopmentUrl : "")}`
              }
            ) }),
            /* @__PURE__ */ jsx("div", { role: !EnvironmentService.enableSubClusterA11yUpdate() ? "cell" : void 0, children: /* @__PURE__ */ jsx(
              TextField,
              {
                label: AriaLabel.StorageAccount,
                required: true,
                ariaLabel: AriaLabel.StorageAccount,
                isReadOnly: !!this.props.isReadOnly,
                description: PlaceHolder.StorageAccount,
                value: `${this.props.subClusterList && this.props.subClusterList[listIndex]["StorageAccount"]}`,
                onChange: (index, newValue) => {
                  this._handleChange(listIndex, newValue, "StorageAccount");
                },
                errorMessage: `${this.props.subClusterList && (this.props.subClusterList.length > 0 ? this.props.subClusterList[listIndex]["required"].StorageAccount : "")}`
              }
            ) }),
            /* @__PURE__ */ jsx("div", { role: !EnvironmentService.enableSubClusterA11yUpdate() ? "cell" : void 0, children: /* @__PURE__ */ jsx(
              TextField,
              {
                label: AriaLabel.StorageContainer,
                required: true,
                ariaLabel: AriaLabel.StorageContainer,
                isReadOnly: !!this.props.isReadOnly,
                description: PlaceHolder.StorageContainer,
                value: `${this.props.subClusterList && this.props.subClusterList[listIndex]["StorageContainer"]}`,
                onChange: (index, newValue) => {
                  this._handleChange(listIndex, newValue, "StorageContainer");
                },
                errorMessage: `${this.props.subClusterList && (this.props.subClusterList.length > 0 ? this.props.subClusterList[listIndex]["required"].StorageContainer : "")}`
              }
            ) }),
            /* @__PURE__ */ jsx("div", { role: !EnvironmentService.enableSubClusterA11yUpdate() ? "cell" : void 0, children: /* @__PURE__ */ jsx(
              TextField,
              {
                label: AriaLabel.PoolName,
                required: true,
                ariaLabel: AriaLabel.PoolName,
                isReadOnly: !!this.props.isReadOnly,
                description: PlaceHolder.PoolName,
                value: `${this.props.subClusterList && this.props.subClusterList[listIndex]["PoolName"]}`,
                onChange: (index, newValue) => {
                  this._handleChange(listIndex, newValue, "PoolName");
                },
                errorMessage: `${this.props.subClusterList && (this.props.subClusterList.length > 0 ? this.props.subClusterList[listIndex]["required"].PoolName : "")}`
              }
            ) }),
            /* @__PURE__ */ jsx("div", { role: !EnvironmentService.enableSubClusterA11yUpdate() ? "cell" : void 0, children: /* @__PURE__ */ jsx(
              TextField,
              {
                label: AriaLabel.ClusterMaxConcurrentJobs,
                required: true,
                ariaLabel: AriaLabel.ClusterMaxConcurrentJobs,
                isReadOnly: !!this.props.isReadOnly,
                description: PlaceHolder.ClusterMaxConcurrentJobs,
                value: `${this.props.subClusterList && this.props.subClusterList[listIndex]["MaxConcurrency"]}`,
                onChange: (index, newValue) => {
                  this._handleChange(listIndex, newValue, "MaxConcurrency");
                },
                errorMessage: `${this.props.subClusterList && (this.props.subClusterList.length > 0 ? this.props.subClusterList[listIndex]["required"].MaxConcurrency : "")}`
              }
            ) }),
            /* @__PURE__ */ jsx("div", { role: !EnvironmentService.enableSubClusterA11yUpdate() ? "cell" : void 0, children: /* @__PURE__ */ jsx(
              DropdownField,
              {
                name: "nodeSize",
                label: AriaLabel.NodeSize,
                required: true,
                isReadOnly: !!this.props.isReadOnly,
                placeholder: PlaceHolder.NodeSize,
                ariaLabel: AriaLabel.NodeSize,
                options: this.onExecutorSizeOption(),
                labelProps: {
                  iconProps: {
                    calloutProps: {
                      content: "We have reserved some memory for our driver, so the memory size might be different from your setting in Synapse Studio."
                    }
                  }
                },
                defaultSelectedKey: this.props.subClusterList ? this.props.subClusterList[listIndex].NodeSize : "",
                errorMessage: this.getTextErrorMessage(listIndex, "NodeSize"),
                onChange: (index, newValue) => {
                  this._handleChange(listIndex, newValue ? newValue.key.toString() : "", "NodeSize");
                }
              }
            ) }),
            /* @__PURE__ */ jsx("div", { role: !EnvironmentService.enableSubClusterA11yUpdate() ? "cell" : void 0, children: /* @__PURE__ */ jsx(
              DropdownField,
              {
                name: "sparkVersion",
                label: AriaLabel.ClusterRuntimeVersion,
                isReadOnly: !!this.props.isReadOnly,
                placeholder: PlaceHolder.ClusterRuntimeVersion,
                ariaLabel: AriaLabel.ClusterRuntimeVersion,
                options: this.onClusterVersionOption(),
                required: true,
                defaultSelectedKey: this.props.subClusterList ? this.props.subClusterList[listIndex].SparkVersion : "",
                errorMessage: this.getTextErrorMessage(listIndex, "SparkVersion"),
                onChange: (index, newValue) => {
                  this._handleChange(listIndex, newValue ? newValue.text : "", "SparkVersion");
                }
              }
            ) }),
            /* @__PURE__ */ jsxs("div", { role: !EnvironmentService.enableSubClusterA11yUpdate() ? "cell" : void 0, children: [
              /* @__PURE__ */ jsx(
                ChoiceGroupField,
                {
                  name: "scaleType",
                  label: AriaLabel.ClusterScale,
                  ariaLabel: AriaLabel.ClusterScale,
                  isReadOnly: !!this.props.isReadOnly,
                  defaultSelectedKey: `${this.props.subClusterList && (this.props.subClusterList[listIndex].ScaleType === "AutoScaling" ? "AutoScaling" : "Fixed")}`,
                  options: [
                    { key: "Fixed", text: "Fixed (default)", ariaLabel: "ClusterScaleFixed" },
                    { key: "AutoScaling", text: "Autoscaling", ariaLabel: "ClusterScaleAutoscaling" }
                  ],
                  required: true,
                  onChange: (ev, option) => {
                    this._handleChange(listIndex, option == null ? void 0 : option.key, "ScaleType");
                  }
                }
              ),
              this._getClusterScaleUI(listIndex)
            ] })
          ]
        }
      );
    });
    __publicField(this, "_handleChange", (index, newValue, columnName) => {
      let subClusterList = [...this.props.subClusterList];
      let subCluster = subClusterList[index];
      if (columnName === "ScaleType") {
        if (newValue === "AutoScaling") {
          subClusterList[index].required.FixedWorkers = "";
          subClusterList[index].required.MinWorkers = getSynapseValidateMessage("MinWorkers", subCluster.MinWorkers);
          subClusterList[index].required.MaxWorkers = getSynapseValidateMessage("MaxWorkers", subCluster.MaxWorkers);
        } else {
          subClusterList[index].required.MinWorkers = "";
          subClusterList[index].required.MaxWorkers = "";
          subClusterList[index].required.FixedWorkers = getSynapseValidateMessage("FixedWorkers", subCluster.FixedWorkers);
        }
      }
      let columnNewValue = "";
      let validationMessage = "";
      if (null != newValue && "" !== newValue.toString().trim()) {
        columnNewValue = newValue;
        validationMessage = this._updateValidateMessage(columnName, newValue, subCluster);
      } else {
        columnNewValue = "";
        validationMessage = "Required";
      }
      subClusterList = [
        ...this.props.subClusterList.slice(0, index),
        __spreadProps(__spreadValues({}, subCluster), {
          [columnName]: columnNewValue,
          required: __spreadProps(__spreadValues({}, subCluster.required), {
            [columnName]: validationMessage
          })
        }),
        ...this.props.subClusterList.slice(index + 1)
      ];
      this.props.setFieldValue && this.props.setFieldValue("synapseSubClusterList", subClusterList, true);
    });
    __publicField(this, "_getClusterScaleUI", (listIndex) => {
      let subClusterList = [...this.props.subClusterList];
      let clusterScale = subClusterList[listIndex].ScaleType;
      if (clusterScale && clusterScale === "AutoScaling") {
        return /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx(
            TextField,
            {
              label: AriaLabel.MinimumWorkersPerTask,
              required: true,
              ariaLabel: AriaLabel.MinimumWorkersPerTask,
              isReadOnly: !!this.props.isReadOnly,
              description: PlaceHolder.MinimumWorkersPerTask,
              value: `${this.props.subClusterList && this.props.subClusterList[listIndex]["MinWorkers"]}`,
              onChange: (index, newValue) => {
                this._handleChange(listIndex, newValue, "MinWorkers");
              },
              errorMessage: `${this.props.subClusterList && (this.props.subClusterList.length > 0 ? this.props.subClusterList[listIndex]["required"].MinWorkers ? this.props.subClusterList[listIndex]["required"].MinWorkers : "" : "")}`
            }
          ),
          /* @__PURE__ */ jsx(
            TextField,
            {
              label: AriaLabel.MaximumWorkersPerTask,
              required: true,
              ariaLabel: AriaLabel.MaximumWorkersPerTask,
              isReadOnly: !!this.props.isReadOnly,
              description: PlaceHolder.MaximumWorkersPerTask,
              value: `${this.props.subClusterList && this.props.subClusterList[listIndex]["MaxWorkers"]}`,
              onChange: (index, newValue) => {
                this._handleChange(listIndex, newValue, "MaxWorkers");
              },
              errorMessage: `${this.props.subClusterList && (this.props.subClusterList.length > 0 ? this.props.subClusterList[listIndex]["required"].MaxWorkers ? this.props.subClusterList[listIndex]["required"].MaxWorkers : "" : "")}`
            }
          )
        ] });
      }
      return /* @__PURE__ */ jsx(
        TextField,
        {
          label: AriaLabel.NumberOfWorkersPerTask,
          required: true,
          ariaLabel: AriaLabel.NumberOfWorkersPerTask,
          isReadOnly: !!this.props.isReadOnly,
          description: PlaceHolder.NumberOfWorkersPerTask,
          value: `${this.props.subClusterList && this.props.subClusterList[listIndex]["FixedWorkers"]}`,
          onChange: (index, newValue) => {
            this._handleChange(listIndex, newValue, "FixedWorkers");
          },
          errorMessage: `${this.props.subClusterList && (this.props.subClusterList.length > 0 ? this.props.subClusterList[listIndex]["required"].FixedWorkers ? this.props.subClusterList[listIndex]["required"].FixedWorkers : "" : "")}`
        }
      );
    });
    __publicField(this, "onClusterVersionOption", () => {
      const items = [
        { key: "Spark 2.4", text: "Spark 2.4" },
        { key: "Spark 3.1", text: "Spark 3.1" },
        { key: "Spark 3.2", text: "Spark 3.2" },
        { key: "Spark 3.3", text: "Spark 3.3" },
        { key: "Spark 3.4", text: "Spark 3.4" }
      ];
      return items;
    });
    __publicField(this, "onExecutorSizeOption", () => {
      const items = [
        { key: "Small", text: "Small, 4 vCores, 28GB memory" },
        { key: "Medium", text: "Medium, 8 vCores, 56GB memory" },
        { key: "Large", text: "Large, 16 vCores, 112GB memory" },
        { key: "XLarge", text: "XLarge, 32 vCores, 224GB memory" },
        { key: "XXLarge", text: "XXLarge, 64 vCores, 400GB memory" }
      ];
      return items;
    });
    __publicField(this, "getTextErrorMessage", (listIndex, key) => {
      return this.props.subClusterList && (this.props.subClusterList.length > 0 ? this.props.subClusterList[listIndex]["required"][key] ? this.props.subClusterList[listIndex]["required"][key] : "" : "");
    });
    this._selection = new Selection({
      onSelectionChanged: () => {
      },
      selectionMode: SelectionMode.multiple,
      getKey: (item) => item.key
    });
  }
  componentDidMount() {
    var _a;
    if (!!!this.props.isUpdateCompute && ((_a = this.props.subClusterList) == null ? void 0 : _a.length) === 0) {
      this.onAddChild();
    }
  }
  render() {
    var _a, _b;
    return /* @__PURE__ */ jsxs(StepContainer, { className: "create-datalocation-info-tab", children: [
      !this.props.isUpdateCompute && /* @__PURE__ */ jsxs(FormHeading, { pageTitle: "Sub-cluster Configuration", children: [
        "This is where you enter information about all your sub-cluster configurations. You may add one or more.",
        /* @__PURE__ */ jsx("a", { href: "/compute", children: "Learn more" })
      ] }),
      /* @__PURE__ */ jsx(FormSection, { children: EnvironmentService.enableSubClusterA11yUpdate() ? /* @__PURE__ */ jsx(
        SubClusterListV2,
        {
          subClusterList: (_a = this.props.subClusterList) != null ? _a : [],
          onRenderSubCluster: this._onRenderRow,
          onAddSubCluster: this.onAddChild,
          onDeleteSubCluster: (index) => {
            let subClusterList = [...this.props.subClusterList];
            subClusterList = subClusterList.filter((item, key) => key !== index);
            this.props.setFieldValue && this.props.setFieldValue("synapseSubClusterList", subClusterList, true);
          },
          isReadOnly: !!this.props.isReadOnly
        }
      ) : /* @__PURE__ */ jsx(
        SubClusterList,
        {
          isUpdateCompute: this.props.isUpdateCompute,
          subClusterList: (_b = this.props.subClusterList) != null ? _b : [],
          selection: this._selection,
          onRenderSubCluster: this._onRenderRow,
          onAddSubCluster: this.onAddChild,
          onDeleteSubCluster: () => {
            let subClusterList = [...this.props.subClusterList];
            subClusterList = subClusterList.filter((item, key) => !!!this._selection.isIndexSelected(key));
            this.props.setFieldValue && this.props.setFieldValue("synapseSubClusterList", subClusterList, true);
          },
          isReadOnly: !!this.props.isReadOnly
        }
      ) })
    ] });
  }
  _updateValidateMessage(name, value, subCluster) {
    let required = "";
    if (value === void 0 || "" === value.toString().trim()) {
      return "Required";
    } else {
      required = getSynapseValidateMessage(name, value);
    }
    if ("" === required && (name === "MinWorkers" || name === "MaxWorkers")) {
      const minWorkers = name === "MinWorkers" ? value : subCluster.MinWorkers === "" ? "1" : subCluster.MinWorkers;
      const maxWorkers = name === "MaxWorkers" ? value : subCluster.MaxWorkers === "" ? Number.MAX_SAFE_INTEGER.toString() : subCluster.MaxWorkers;
      required = validateMinMaxWorkers(minWorkers, maxWorkers);
      subCluster.required.MinWorkers = required;
      subCluster.required.MaxWorkers = required;
    }
    return required;
  }
}
const SynapseSubClusterComponent$1 = connect(mapStateToProps)(
  SynapseSubClusterComponent
);
const getValidateMessage = (name, value) => {
  if (!value || "" === value.toString().trim()) {
    return `${name} required`;
  }
  switch (name.toLowerCase()) {
    case "fixedworkers":
    case "minworkers":
    case "maxworkers":
    case "maxconcurrency":
      if (!/^[0-9]*[1-9][0-9]*$/.test(value)) {
        return "Please enter an integer greater than 0";
      }
      break;
    case "cluster":
      if (!/^cosmos[0-9]{2}$/.test(value)) {
        return "The field cluster must match the placeholder expression. e.g. cosmos09";
      }
      break;
    case "name":
      if (!/^[a-z0-9_.-]{1,128}$/.test(value)) {
        return "Name is invalid. Only lowercase alphanumeric characters, hyphens, and underscores are allowed.";
      }
      break;
    case "vcname":
      if (!/^[\w][\w.-]{0,50}$/.test(value)) {
        return "Please enter a valid compute name.";
      }
      break;
    case "keyvaulturl":
    case "developmenturl":
      try {
        new URL(value);
      } catch (_) {
        return "Require url";
      }
      break;
    default:
      return "";
  }
};
const validateMinMaxWorkers = (minworkersString, maxworkersString) => {
  if (minworkersString && maxworkersString) {
    const minworkers = Number.parseInt(minworkersString);
    const maxworkers = Number.parseInt(maxworkersString);
    if (!isNaN(maxworkers) && !isNaN(minworkers) && minworkers > maxworkers) {
      return "Values of maxworkers is less than minworkers";
    }
  }
  return "";
};
const validateSparkComputeType = (sparkComputeType) => {
  let validSparkComputeType = Object.keys(ComputeType).map((key) => ComputeType[key]).filter((value) => typeof value === "string");
  return validSparkComputeType.filter((computeType) => sparkComputeType === computeType).length === 0;
};
const validateBasicInfo = (values, props) => {
  const isClassicWorkspace = isClassicWorkspaceById(props.workspaceId ? props.workspaceId : "");
  const errors = {};
  const nameError = getValidateMessage("Name", values.name);
  if (nameError)
    errors.name = nameError;
  if (validateSparkComputeType(values.sparkComputeType)) {
    errors.sparkComputeType = "Required";
  }
  if (values.sparkComputeType === ComputeType.CosmosVC) {
    const clusterError = getValidateMessage("Cluster", values.cluster);
    if (clusterError)
      errors.cluster = clusterError;
    const vcNameError = getValidateMessage("VCName", values.vcName);
    if (vcNameError)
      errors.vcName = vcNameError;
  }
  if (values.sparkComputeType === ComputeType.BlueshiftADLA) {
    const adlaAccountNameError = getValidateMessage("adlaAccountName", values.adlaAccountName);
    if (adlaAccountNameError)
      errors.adlaAccountName = adlaAccountNameError;
    const defaultStorageAccountNameError = getValidateMessage("defaultStorageAccountName", values.defaultStorageAccountName);
    if (defaultStorageAccountNameError)
      errors.defaultStorageAccountName = defaultStorageAccountNameError;
  }
  if (values.sparkComputeType === ComputeType.CosmosADLA) {
    const adlaAccountNameError = getValidateMessage("adlaAccountName", values.adlaAccountName);
    if (adlaAccountNameError)
      errors.adlaAccountName = adlaAccountNameError;
  }
  const managedIdentityIdError = getValidateMessage("managedIdentityId", values.managedIdentityId);
  const servicePrincipalNameError = getValidateMessage("servicePrincipalName", values.servicePrincipalName);
  if (values.authenticationType === AuthenticationType.ManagedIdentity) {
    if (managedIdentityIdError)
      errors.managedIdentityId = managedIdentityIdError;
  } else if (values.authenticationType === AuthenticationType.ServicePrincipal) {
    if (servicePrincipalNameError)
      errors.servicePrincipalName = servicePrincipalNameError;
  } else if (values.sparkComputeType === ComputeType.CosmosADLA || values.sparkComputeType === ComputeType.BlueshiftADLA) {
    if (showMSIOption(props.workspaceId) && !values.authenticationType && !values.servicePrincipalName && managedIdentityIdError) {
      errors.managedIdentityId = managedIdentityIdError;
    } else if (!showMSIOption(props.workspaceId) && !values.authenticationType && !values.managedIdentityId && servicePrincipalNameError) {
      errors.servicePrincipalName = servicePrincipalNameError;
    }
  }
  if (!!isClassicWorkspace && (!values.owners || values.owners.length === 0)) {
    errors.owners = "Required";
  }
  return errors;
};
const validateSynapse = (subClusterList) => {
  if (!subClusterList || subClusterList.length === 0)
    return true;
  let error = false;
  subClusterList.forEach((subCluster) => {
    if (getSynapseValidateMessage("Name", subCluster.Name) !== "")
      error = true;
    if (getSynapseValidateMessage("DevelopmentUrl", subCluster.DevelopmentUrl) !== "")
      error = true;
    if (getSynapseValidateMessage("StorageAccount", subCluster.StorageAccount) !== "")
      error = true;
    if (getSynapseValidateMessage("StorageContainer", subCluster.StorageContainer) !== "")
      error = true;
    if (getSynapseValidateMessage("PoolName", subCluster.PoolName) !== "")
      error = true;
    if (getSynapseValidateMessage("MaxConcurrency", subCluster.MaxConcurrency) !== "")
      error = true;
    if (getSynapseValidateMessage("NodeSize", subCluster.NodeSize) !== "")
      error = true;
    if (subCluster.ScaleType === ClusterScale.Fixed) {
      if (getSynapseValidateMessage("FixedWorkers", subCluster.FixedWorkers) !== "")
        error = true;
    } else if (subCluster.ScaleType === ClusterScale.AutoScaling) {
      if (getSynapseValidateMessage("MinWorkers", subCluster.MinWorkers) !== "")
        error = true;
      if (getSynapseValidateMessage("MaxWorkers", subCluster.MaxWorkers) !== "")
        error = true;
      const minWorkers = subCluster.MinWorkers === "" ? "1" : subCluster.MinWorkers;
      const maxWorkers = subCluster.MaxWorkers === "" ? Number.MAX_SAFE_INTEGER.toString() : subCluster.MaxWorkers;
      if (validateMinMaxWorkers(minWorkers, maxWorkers) !== "")
        error = true;
    } else {
      error = true;
    }
    if (getSynapseValidateMessage("SparkVersion", subCluster.SparkVersion) !== "")
      error = true;
  });
  return error;
};
const validateSubCluster = (values, existingErrors) => {
  var _a;
  if (values.sparkComputeType === ComputeType.Synapse) {
    if (validateSynapse(values.synapseSubClusterList))
      existingErrors.synapseSubClusterList = "Error in synapse";
  } else if (!values.sparkComputeType) {
    const sparkComputeTypeError = getValidateMessage("sparkComputeType", values.sparkComputeType);
    if (sparkComputeTypeError)
      existingErrors.sparkComputeType = sparkComputeTypeError;
  } else if (!!((_a = values.maxConcurrency) == null ? void 0 : _a.trim())) {
    const maxConcurrencyError = getValidateMessage("MaxConcurrency", values.maxConcurrency);
    if (maxConcurrencyError)
      existingErrors.maxConcurrency = maxConcurrencyError;
  }
  return existingErrors;
};
const showMSIOption = (workspaceId) => {
  return EnvironmentService.enableMSIForCMS() && !isClassicWorkspaceById(workspaceId);
};
export {
  ClusterScale as C,
  DefaultNodeSize as D,
  SynapseSubClusterComponent$1 as S,
  validateSubCluster as a,
  validateSparkComputeType as b,
  SynapseSubClusterComponent as c,
  getValidateMessage as d,
  validateMinMaxWorkers as e,
  getSynapseValidateMessage as g,
  showMSIOption as s,
  validateBasicInfo as v
};
//# sourceMappingURL=ComputeFormikSettingsUtils-baaa5d0e.js.map
